import PedidoInterface from "@/interfaces/Pedido";
import axios from "axios";

class PedidoService {
    async getNfeXml(data: { chaveAcesso: string }): Promise<string> {
        return (await axios.get(`pedido/xml/${data.chaveAcesso}`)).data;
    }

    async getAcompanhamento(data: { nroPedido: number }): Promise<any> {
        return await axios.get("pedido/acompanhamento/" + data.nroPedido);
    }

    async getAllProdutosFromPedidos(filter: { search: string }, pagination: { page: number; itemsPerPage: number }): Promise<any> {
        return axios.post("produto/produtosTroca", { filter, pagination });
    }

    findOne(id: number): Promise<any> {
        return axios.get("pedido/id/" + id);
    }

    findOneByNroPedido(nroPedido: string): Promise<any> {
        return axios.get("pedido/details/" + nroPedido);
    }

    findAll(paginacao: any, ordenacao: any, filtros: any, todosClientes?: boolean, produtos?: boolean): Promise<any> {

        const filtro = {
            searchStr: filtros.search,
            situacao: filtros.situacao,
            todosClientes: todosClientes,
            produtos: produtos,
            origem: filtros.origem,
            tipoPedido: filtros.tipoPedido,
        };

        const params = {
            dtini: filtros.periodo?.dtIni || null,
            dtfim: filtros.periodo?.dtFim || null,
        };

        const headers = {
            pagination: JSON.stringify({ ...paginacao, ...ordenacao }),
            filter: JSON.stringify(filtro),
        };

        return axios
            .get("pedido/", {
                headers: headers,
                params: Object.keys(params).length > 0 ? params : undefined,
            })
            .then((resp: any) => {
                return {
                    totalItensServer: +resp?.data?.totalRecordCount || 0,
                    valorTotal: +resp?.data?.valorTotal || 0,
                    tableStatusText: "Pronto",
                    listaPedidos: resp?.data?.data || [],
                }
            });
    }

    findPortadores(): Promise<any> {
        return axios.get("pagamento/portadores");
    }

    findCondicoesPgto(): Promise<any> {
        return axios.get("pagamento/condicoespgto");
    }

    findAllPortadores(): Promise<any> {
        return axios.get("pagamento/allportadores");
    }

    findAllCondicoesPgto(): Promise<any> {
        return axios.get("pagamento/allcondicoespgto");
    }

    salvarPedido(pedido: any): Promise<any> {
        return axios.post("pedido/", pedido);
    }

    excluirPedido(pedidoId: any): Promise<any> {
        return axios.delete("pedido/" + pedidoId);
    }


    async getPedidoEdicao(): Promise<PedidoInterface> {
        return axios.get("pedido/carrinho").then(
            (resp: any) => {
                return resp.data;
            });
    }

    async getNfePdf(data: { chaveAcesso: string, nroPedido: number }): Promise<any> {
        return axios.get(`pedido/pdf/${data.chaveAcesso}/${data.nroPedido}`, { responseType: "blob" }).then((resp: any) => resp.data);
    }

    async getFaturaPdf(data: { nroVenda: number }): Promise<any> {
        return axios.get(`pedido/fatura/${data.nroVenda}`, { responseType: "blob" }).then((resp: any) => resp.data);
    }
}

export default new PedidoService();
